import colors from "../../base/colors";
import borders from "../../base/borders";

import pxToRem from "../../functions/pxToRem";

const { primary, divider } = colors;
const { borderRadius } = borders;

/** Fluent pivot / TabList: flat track with a hairline, selection shown by an accent underline. */
const tabs = {
  styleOverrides: {
    root: {
      position: "relative" as const,
      backgroundColor: "transparent",
      border: "none",
      borderBottom: `1px solid ${divider}`,
      borderRadius: 0,
      minHeight: "unset",
      padding: 0,
    },

    flexContainer: {
      height: "100%",
      position: "relative" as const,
      zIndex: 10,
      gap: pxToRem(2),
    },

    fixed: {
      overflow: "unset !important" as any,
      overflowX: "unset !important" as any,
    },

    vertical: {
      borderBottom: "none",
      borderRight: `1px solid ${divider}`,
      "& .MuiTabs-indicator": {
        width: pxToRem(3),
        height: "auto",
        borderRadius: borderRadius.sm,
      },
    },

    indicator: {
      height: pxToRem(3),
      borderRadius: `${pxToRem(3)} ${pxToRem(3)} 0 0`,
      backgroundColor: primary.main,
      boxShadow: "none",
      transition: "all 200ms cubic-bezier(0.33, 0, 0.67, 1)",
      zIndex: 1,
    },
  },
};

export default tabs;
